<template>
    <div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'ClearLayout',
    }
</script>
<style lang="scss">
</style>
